import { useMemo } from 'react';
import { parseISO } from 'date-fns';

import { useProfile } from 'context/profile';

/**
 * Gets the SNF launch date from the client_group_type config.
 * This limits how far back the user can navigate in the calendar.
 */
export default function useSnfLaunchDate(): Date | null {
  const { profile } = useProfile();

  const snfClientGroupType = profile.actingClient?.clientGroupTypes?.find(
    (cgt) => cgt.groupType?.apiName === 'skilled_nursing_facility' && cgt.serviceType === 'managed'
  );

  return useMemo(
    () => (snfClientGroupType?.config?.launchDate ? parseISO(snfClientGroupType.config.launchDate) : null),
    [snfClientGroupType]
  );
}
